<mat-dialog-content class="h-full !p-0 rounded-lg !ml-0">
  <div class="flex flex-col place-items-center items-stretch bg-white p-5">

    <div class="text-base font-semibold text-base mr-96">{{questionTrans}}</div>

    <div class="flex flex-col ">
      <div *ngFor="let model of models" class="font-semibold break-all text-xs my-2">{{model.link.name}}</div>
    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="mt-4 flex items-center">
    <app-button id="confirm" [isLoading]="isLoading" [isActive]="true" innerTextClasses="text-sm mx-6" spinnerClasses="mx-7 my-1.5"
                label="{{'labels.remove' | translate | titlecase}}" (click)="onRemove()"></app-button>

    <sm-button-transparent label="{{'labels.cancel' | translate  | titlecase}}" class="ml-5"
                           (click)="onClose()"></sm-button-transparent>
  </div>
</div>
